import React, { useState, useMemo } from "react";
import { withTranslation } from "react-i18next";
import DestinationShipmentData from "../DestinationShipmentData/DestinationShipmentData";
import TelemetryVariantSwitch from "../TelemetryVariantSwitch/TelemetryVariantSwitch";
import TelemetryPanel from "../TelemetryPanel/TelemetryPanel";
import {
  getTelemetryViewState,
  getTelemetryViewMessage,
  formatMacDatalogger,
} from "../../utils/shipmentTelemetryViewUtils";

function OnlineDataLoggerShipmentData({
  shipmentParameters,
  telemetryInfo,
  alertsListInfo,
  chartsInfo,
  batteryLevels,
  stepsRef,
}) {
  const { imei, macMando, destinationData, numRefClient } = shipmentParameters;

  const [variant, setVariant] = useState("full");

  const view = useMemo(
    () => getTelemetryViewState({ chartsInfo, variant }),
    [chartsInfo, variant]
  );

  const viewMessage = useMemo(() => getTelemetryViewMessage(view), [view]);

  const macDatalogger = useMemo(
    () => formatMacDatalogger(macMando),
    [macMando]
  );

  const isTelemetryOk = view.state === "ok";

  return (
    <div>
      <DestinationShipmentData destinationData={destinationData} />
      <br />

      <h2>
        Referencia cliente/pedido:{" "}
        <span className="shipment-info">{numRefClient}</span>
      </h2>

      <h2>
        Tipo de datalogger:{" "}
        <span className="shipment-info">On-Line {macDatalogger}</span>
      </h2>

      <h2>
        IMEI de caja: <span className="shipment-info">{imei}</span>
      </h2>

      <div
        style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}
      >
        <TelemetryVariantSwitch variant={variant} onChange={setVariant} />
      </div>

      {!isTelemetryOk ? (
        <h4 style={{ height: "20vw", textAlign: "center", paddingTop: "8vw" }}>
          {viewMessage}
        </h4>
      ) : (
        <>
          <TelemetryPanel
            shipmentCode={shipmentParameters.shipmentCode}
            telemetryInfo={telemetryInfo}
            alertsListInfo={alertsListInfo}
            chartsInfo={chartsInfo}
            batteryLevels={batteryLevels}
            isStandalone={shipmentParameters.standalone}
            variant={variant}
            stepsRef={stepsRef}
          />
        </>
      )}
    </div>
  );
}

export default withTranslation()(OnlineDataLoggerShipmentData);
